import React, { useEffect, useState } from 'react'
import DataTablePagination from '../../component/data_table/DataTablePagination'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import * as Yup from "yup";
import { IoRefreshOutline } from 'react-icons/io5'
import Flatpickr from 'react-flatpickr'
import Select from 'react-select'
import "flatpickr/dist/themes/light.css"
import { LuChevronLeft, LuChevronRight, LuPrinter } from 'react-icons/lu'
import { useFormik } from 'formik';
import Loader from '../../component/loader/Loader';
import SaveButton from '../../component/buttons/SaveButton';
import { toast, ToastContainer } from 'react-toastify';
import { DebitCreditListRes, DebitCreditListTodo } from '../../redux/Slices/debit-credit-note/DebitCreditList';
import { DebitCreditPdfRes, DebitCreditPdfTodo } from '../../redux/Slices/debit-credit-note/DebitCreditPdf';
import { FinyearListRes, FinyearListTodo } from '../../redux/Slices/LoginSlice/FinYearList';

export default function DebitCreditList() {

    const dispatch = useDispatch()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pageLimit, setPageLimit] = useState(300)
    const [tableLoading, setTableLoading] = useState(false)
    const [pageSize, setPageSize] = useState(1)
    const [filterLoad, setFilterLoad] = useState(false)

    const debitcreditnote = useSelector(state => state?.DebitCreditNote?.data?.data)
    const finyear_list = useSelector(state => state?.FinYearList?.data?.data)

    const trans_option = [
        { "value": 'A', "label": "All" },
        { "value": "D", "label": "Debit Note" },
        { "value": "C", "label": "Credit Note" },

    ]

    const fin_year_option = finyear_list && finyear_list.map(val => (
        { "value": val.vfin_year_short_name, "label": val.vfin_year_name }
    ));

    const ValidationSchema = Yup.object({
        fin_year: Yup.string().required("Select Finanacial Year"),

    });
    const initialValues = {
        fromDate: '',
        toDate: '',
        trans: '',
        fin_year: ''

    }


    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: ValidationSchema,

        onSubmit: (values, action) => {

            setFilterLoad(true)
            dispatch(DebitCreditListTodo({ "fromDate": values.fromDate, "toDate": values.toDate, "trans": values.trans, 'fin_year': values?.fin_year, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res())
        }
    })

    const PageSizeFun = (data) => {
        setTableLoading(true)
        setPageLimit(data)
        dispatch(DebitCreditListTodo({ "fromDate": values.fromDate, "toDate": values.toDate, "trans": values.trans, 'fin_year': values?.fin_year, "pageLimit": data, "pageSize": 1 })).then(() => filter_res2())
    }

    const nextPageFun = () => {
        setTableLoading(true)
        setPageSize(prev => prev + 1);
        dispatch(DebitCreditListTodo({ "fromDate": values.fromDate, "toDate": values.toDate, "trans": values.trans, 'fin_year': values?.fin_year, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res2())
    }
    const prevPageFun = () => {
        setTableLoading(true)
        setPageSize(prev => prev - 1);
        dispatch(DebitCreditListTodo({ "fromDate": values.fromDate, "toDate": values.toDate, "trans": values.trans, 'fin_year': values?.fin_year, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res2())
    }

    const filter_res = () => {
        if (DebitCreditListRes && DebitCreditListRes.status) {
            setFilterLoad(false)
        } else {
            setFilterLoad(false)
        }
    }

    const filter_res2 = () => {
        if (DebitCreditListRes?.status) {
            setTableLoading(false)
        } else {
            setTableLoading(false)

        }
    }

    const handleReset = () => {
        // setLoading(true)
        setFieldValue('trans', "");   // Reset search
        setFieldValue('fromDate', "");   // Reset search
        setFieldValue('toDate', "");
        setFieldValue('fin_year', "");   // Reset search
        dispatch(DebitCreditListTodo())
        setBool(!bool);                 // Toggle bool state if necessary

    };
    useEffect(() => {
        setLoading(true)
        dispatch(FinyearListTodo()).then(() => list_res())
    }, [bool])

    const list_res = () => {
        if (FinyearListRes?.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (pageLimit > 300 || pageSize > 1) {
            dispatch(DebitCreditListTodo({ "fromDate": values.fromDate, "toDate": values.toDate, "trans": values.trans, 'fin_year': values?.fin_year, "pageLimit": pageLimit, "pageSize": pageSize }))
        }
    }, [pageLimit, pageSize])

    const pdfGenrate = (data) => {
        setFilterLoad(true)
        dispatch(DebitCreditPdfTodo(data.vtrans_code)).then(() => pdf_res())
    }

    const pdf_res = () => {
        if (DebitCreditPdfRes && DebitCreditPdfRes.status) {
            setFilterLoad(false)
            toast.success(DebitCreditPdfRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                window.open(DebitCreditPdfRes?.return_file, '_blank');
            }, 1500);


        } else {
            setFilterLoad(false)
            toast.error(DebitCreditPdfRes?.message, { position: "bottom-right" });
        }
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            field: 'filedName',
            valueGetter: `${pageLimit * pageSize} + (node.rowIndex + 1) - ${pageLimit}`,
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            wrapText: true,
            autoHeight: true,
            maxWidth: 70
        },

        {
            headerName: 'TRANSACTION CODE',
            field: 'vtrans_code',
            // cellRenderer: params => <span>{params?.data?.mweight + ' ' + params?.data?.vunit_short_name}</span>,
            cellRenderer: params => <span onClick={() => pdfGenrate(params?.data)} style={{ fontSize: '16px', fontWeight: "600", color: 'red', cursor: 'pointer' }}>{params?.data?.vtrans_code}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 200,
            wrapText: true,
            autoHeight: true,
        },


        {
            headerName: 'TRANSACTION DATE',
            field: 'sgate_date',
            cellRenderer: params => <span>{params?.data?.vtrans_date}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 200,
            wrapText: true,
            autoHeight: true,

        },
        {
            headerName: 'ACCOUNT NAME',
            field: 'vcustomer_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 200,
            wrapText: true,
            autoHeight: true,
        },
        {
            headerName: 'TRANSACTION AMT.',
            field: 'mtotal_amount',
            cellRenderer: params => params?.data?.mtotal_amount?.toFixed(2),
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            wrapText: true,
            autoHeight: true,
            maxWidth: 200
        },
        {
            headerName: 'VIRN NO',
            field: 'virn_no',
            // cellRenderer: params => <span>{params?.data?.mrate + ' ' + params?.data?.vunit_short_name}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // maxWidth: 130
            wrapText: true,
            autoHeight: true,
        },
    ]
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head'>
                            <h5> Debit Credit Note List</h5>
                        </div>
                        {loading ?
                            <div className='mt-5 pt-5'>
                                <Loader />
                            </div>
                            :
                            <div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className='col-md-3' >
                                            <label htmlFor="" className='form_label'>Select trans </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                // placeholder='Select trans'
                                                options={trans_option}
                                                className='react_select'
                                                // ref={selectSchemRef}
                                                classNamePrefix="select"
                                                isClearable
                                                name="trans"
                                                onChange={(e) => {
                                                    setFieldValue("trans", e?.value)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>From Date</label>

                                            <Flatpickr
                                                className='form_input form-control'
                                                name='fromDate'
                                                // value={values?.fromDate || new Date().toISOString()}
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: 'm-d-Y', // Customize date format as needed
                                                    minDate: '', // Before dates disabled
                                                    maxDate: '', // After dates disabled
                                                    disable: [], // Disable particular date ranges
                                                    mode: "single", //multiple-single-range
                                                    defaultDate: [], // Use today's date as default if none selected
                                                    conjunction: "", // Multiple dates separation
                                                }}
                                                onChange={(e) => {
                                                    setFieldValue('fromDate', moment(e[0]).format("DD/MM/YYYY"))
                                                }}
                                                onBlur={handleBlur}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>To Date</label>

                                            <Flatpickr
                                                className='form_input form-control'
                                                name='toDate'
                                                // value={values?.toDate || new Date().toISOString()}
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: 'm-d-Y', // Customize date format as needed
                                                    minDate: '', // Before dates disabled
                                                    maxDate: '', // After dates disabled
                                                    disable: [], // Disable particular date ranges
                                                    mode: "single", //multiple-single-range
                                                    defaultDate: [], // Use today's date as default if none selected
                                                    conjunction: "", // Multiple dates separation
                                                }}
                                                onChange={(e) => {
                                                    setFieldValue('toDate', moment(e[0]).format("DD/MM/YYYY"))
                                                }}
                                                onBlur={handleBlur}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>Select Finanacial Year <span style={{ color: 'red' }}>*</span></label>

                                            <Select
                                                closeMenuOnSelect={true}
                                                // placeholder='Select Month'
                                                options={fin_year_option}
                                                className='react_select'
                                                // ref={selectSchemRef}
                                                classNamePrefix="select"
                                                isClearable
                                                name="fin_year"
                                                onChange={(e) => {
                                                    setFieldValue("fin_year", e?.value)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            {errors.fin_year && touched.fin_year ? (<span className='text-danger form_label' >{errors.fin_year}</span>) : null}

                                        </div>

                                        <div className="col-md-12 d-flex justify-content-end">
                                            <div className='d-flex align-items-center mt-2'>
                                                <SaveButton name={'Filter'} />
                                                <button className='ms-1 refresh_btn' onClick={handleReset} ><IoRefreshOutline style={{ color: 'white' }} size={25} /></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                {/* <div className='d-flex align-items-center'>
                                        <Button variant='primary' size='sm' onClick={() => handlePdf()}>
                                            Print <LuPrinter />
                                        </Button>
                                        <Button className='ms-2' variant='primary' size='sm' onClick={() => downloadFile()} >
                                            Excel Download <FaRegFileExcel />
                                        </Button>
                                    </div> */}
                                <div >
                                    {
                                        filterLoad ?
                                            <div className='mt-5 pt-5'>
                                                <Loader />
                                            </div>
                                            :
                                            debitcreditnote?.length ?
                                                <div className='mt-2'>
                                                    <DataTablePagination
                                                        rowData={debitcreditnote || []}
                                                        columnDefs={columnDefs}
                                                        loading={tableLoading}
                                                        height={'60vh'}
                                                    />
                                                    <div className='text-end pgn_tbl_footer mb-2'>
                                                        <div className='d-flex justify-content-end align-items-center'>
                                                            <div className="d-flex align-items-center">
                                                                <label htmlFor="" className="form-label form_label" style={{ marginBottom: 0 }}>Page Size</label>
                                                                <select className="form-select form_input ms-2" style={{ width: '12vh' }} onChange={(e) => { PageSizeFun(e.target.value) }}>
                                                                    <option value="10">10</option>
                                                                    <option value="20">20</option>
                                                                    <option value="50">50</option>
                                                                    <option value="100">100</option>
                                                                    <option value="150">150</option>
                                                                    <option value="200">200</option>
                                                                </select>
                                                            </div>
                                                            <div className='d-flex align-items-center ms-3 table_footer_pagination' style={{ marginRight: '15px' }}>
                                                                <button type='button' disabled={pageSize === 1 ? true : false} onClick={() => { prevPageFun() }} className='btn pg_btn'><span className='me-2'><LuChevronLeft style={{ marginBottom: '2px' }} size={20} /></span></button>
                                                                <p><span>{pageLimit * pageSize - pageLimit + 1}</span> to <span>{pageLimit * pageSize - pageLimit + debitcreditnote?.length}</span></p>
                                                                <button type='button' disabled={debitcreditnote?.length < pageLimit ? true : false} onClick={() => { nextPageFun() }} className='btn pg_btn'>   <span className='ms-2'><LuChevronRight style={{ marginBottom: '2px' }} size={20} /></span></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div className='empty_section mt-3'>
                                                    <span>DATA NOT FOUND</span>
                                                </div>
                                    }
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}
